import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { FormBuilderService } from '../services/form-builder.service';
import { FieldDefinitionService } from '../services/field-definition.service';

@Injectable()
export class FormResolver implements Resolve<any> {
    constructor(private formBuilderService: FormBuilderService, private fieldDefinitionService: FieldDefinitionService, private router: Router) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        let id = route.params['id'];

        // 11-10-2022 note:  need to find a simpler way to load all field definition objects from the server.
        return this.fieldDefinitionService.getAll().then(ignoredResponse => {
            if (id == 0) {
                var siteIdFromParentRoute = route.parent.data.currentSite.id;
                return this.formBuilderService.newForm(siteIdFromParentRoute).then(response => {
                    return response;
                });
            } else {
                return this.formBuilderService.get(id).then(response => {
                    response.restoreTransientProperties();
                    return response;
                });
            }
        });
    }
}
